import React from 'react';
import { CreditCard, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const EmptyState = () => {
    return (
        <div className="flex flex-col items-center justify-center py-12 px-4">
            <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <CreditCard className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-lg font-semibold text-center mb-2">
                No credit transactions yet
            </h3>
            <p className="text-muted-foreground text-center mb-6 max-w-sm">
                Start analyzing websites or purchase credits to see your transaction history here.
            </p>
            <Link to="/buy-credits">
                <Button className="flex items-center gap-2">
                    Get Credits
                    <ArrowRight className="h-4 w-4" />
                </Button>
            </Link>
        </div>
    );
};

export default EmptyState;